import translations from './translations';
import {getDocumentLang} from './utils';

let lang = null;

export default function t(str) {
  if (!str) {
    return '';
  }
  if (!lang) {
    lang = getDocumentLang();
  }
  if (lang === 'en') {
    return str;
  }
  const search = translations.find(
    values => values.en.toLowerCase() === str.toLowerCase()
  );
  if (search && search[lang]) {
    return search[lang];
  }

  return str;
}
